module.exports = __webpack_public_path__ + "img/Hawaiian Poke Wrap-Ahi Tuna.7e1e4216.jpg";